import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "row wrap" }, "Current status", -1 /* HOISTED */)
const _hoisted_3 = { class: "q-pl-lg q-pt-lg row" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "row justify-start q-ml-xl" }
const _hoisted_6 = { class: "col-4 row" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  class: "text-weight-thin q-ml-sm q-mt-sm",
  "data-test": "last-failure-type"
}
const _hoisted_9 = {
  key: 0,
  class: "col-4"
}
const _hoisted_10 = {
  key: 1,
  class: "col-4 row"
}
const _hoisted_11 = {
  key: 0,
  class: "column q-ml-sm"
}
const _hoisted_12 = {
  key: 1,
  class: "q-ml-sm q-mt-sm"
}
const _hoisted_13 = {
  key: 2,
  class: "col-4"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_15 = {
  key: 0,
  class: "q-ml-xl",
  style: {"font-weight":"bold","color":"grey"}
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  key: 1,
  class: "row justify-start q-ml-xl"
}
const _hoisted_19 = { class: "col-4 column" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, "Stage 1:", -1 /* HOISTED */)
const _hoisted_21 = { class: "row" }
const _hoisted_22 = {
  key: 0,
  class: "col-4"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, "Stage 2:", -1 /* HOISTED */)
const _hoisted_24 = { class: "row" }
const _hoisted_25 = {
  key: 1,
  class: "col-4"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", null, "Stage 3:", -1 /* HOISTED */)
const _hoisted_27 = { class: "row" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_EquipmentStatusSelector = _resolveComponent("EquipmentStatusSelector")!
  const _component_QualityKpi = _resolveComponent("QualityKpi")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_ctx.equipment)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_q_card, { class: "q-mb-lg" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "row justify-between card-title" }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_q_separator),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_EquipmentStatusSelector)
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_QualityKpi, {
                  "information-type": _ctx.informationType.OIL
                }, null, 8 /* PROPS */, ["information-type"]),
                (
              _ctx.equipment.equipmentModel.system === _ctx.equipmentSystem.TRANSFORMERS
            )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.getLastFailureType), 1 /* TEXT */)
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              (
            _ctx.equipment.equipmentModel.system !== _ctx.equipmentSystem.TRANSFORMERS
          )
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(_component_QualityKpi, {
                      "information-type": _ctx.informationType.VIBRATION
                    }, null, 8 /* PROPS */, ["information-type"])
                  ]))
                : _createCommentVNode("v-if", true),
              (
            _ctx.equipment.equipmentModel.system !== _ctx.equipmentSystem.TRANSFORMERS
          )
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createVNode(_component_QualityKpi, {
                      "information-type": _ctx.informationType.PERFORMANCE
                    }, null, 8 /* PROPS */, ["information-type"]),
                    (_ctx.equipment.performanceTagValue !== null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createElementVNode("span", null, _toDisplayString(Number(_ctx.equipment.performanceTagValue)?.toFixed(2)) + "%", 1 /* TEXT */),
                          _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(_ctx.equipment.lastPerformanceTagValueUpdated)), 1 /* TEXT */)
                        ]))
                      : _createCommentVNode("v-if", true),
                    (_ctx.equipment.performanceTagValue === null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, " No data "))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true),
              (
            _ctx.equipment.equipmentModel.system === _ctx.equipmentSystem.TRANSFORMERS
          )
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createVNode(_component_QualityKpi, {
                      "information-type": _ctx.informationType.INSULATION
                    }, null, 8 /* PROPS */, ["information-type"])
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            _hoisted_14,
            (
          _ctx.getEquipmentDetails.driven === 'Compressor' ||
          _ctx.getEquipmentDetails.driven === 'Pump'
        )
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  (_ctx.getEquipmentDetails.driven === 'Pump')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, "Mechanical Seal:"))
                    : _createCommentVNode("v-if", true),
                  (_ctx.getEquipmentDetails.driven === 'Compressor')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, " Dry Gas Seal: "))
                    : _createCommentVNode("v-if", true)
                ]))
              : _createCommentVNode("v-if", true),
            (
          _ctx.getEquipmentDetails.driven === 'Compressor' ||
          _ctx.getEquipmentDetails.driven === 'Pump'
        )
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_QualityKpi, {
                        "information-type": _ctx.informationType.DRY_GAS_SEAL,
                        "dry-gas-seal-type": _ctx.dryGasSealType.S1DE
                      }, null, 8 /* PROPS */, ["information-type", "dry-gas-seal-type"]),
                      _createVNode(_component_QualityKpi, {
                        "information-type": _ctx.informationType.DRY_GAS_SEAL,
                        "dry-gas-seal-type": _ctx.dryGasSealType.S1NDE
                      }, null, 8 /* PROPS */, ["information-type", "dry-gas-seal-type"])
                    ])
                  ]),
                  (_ctx.getEquipmentDetails.driven !== 'Pump')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _hoisted_23,
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(_component_QualityKpi, {
                            "information-type": _ctx.informationType.DRY_GAS_SEAL,
                            "dry-gas-seal-type": _ctx.dryGasSealType.S2DE
                          }, null, 8 /* PROPS */, ["information-type", "dry-gas-seal-type"]),
                          _createVNode(_component_QualityKpi, {
                            "information-type": _ctx.informationType.DRY_GAS_SEAL,
                            "dry-gas-seal-type": _ctx.dryGasSealType.S2NDE
                          }, null, 8 /* PROPS */, ["information-type", "dry-gas-seal-type"])
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  (_ctx.getEquipmentDetails.driven !== 'Pump')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _hoisted_26,
                        _createElementVNode("div", _hoisted_27, [
                          _createVNode(_component_QualityKpi, {
                            "information-type": _ctx.informationType.DRY_GAS_SEAL,
                            "dry-gas-seal-type": _ctx.dryGasSealType.S3DE
                          }, null, 8 /* PROPS */, ["information-type", "dry-gas-seal-type"]),
                          _createVNode(_component_QualityKpi, {
                            "information-type": _ctx.informationType.DRY_GAS_SEAL,
                            "dry-gas-seal-type": _ctx.dryGasSealType.S3NDE
                          }, null, 8 /* PROPS */, ["information-type", "dry-gas-seal-type"])
                        ])
                      ]))
                    : _createCommentVNode("v-if", true)
                ]))
              : _createCommentVNode("v-if", true),
            _hoisted_28
          ]),
          _: 1 /* STABLE */
        })
      ]))
    : _createCommentVNode("v-if", true)
}